import { AnchorButton, ManageableItemsList } from '@payaca/ambrosia';
import { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';

import useGetDocumentBlueprints from '@/api/queries/documentBlueprints/useGetDocumentBlueprints';
import { useHistory } from 'react-router';
import AuthenticatedPageWrapper from '../pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';

const DocumentBlueprintLibraryPage: FC = () => {
  const history = useHistory();

  const { data, isLoading } = useGetDocumentBlueprints();

  const blueprints = useMemo(() => data?.documentBlueprints ?? [], [data]);

  return (
    <AuthenticatedPageWrapper
      breadcrumbItems={[{ label: 'Document blueprints' }]}
    >
      <div className="p-4">
        <ManageableItemsList>
          <ManageableItemsList.HeaderBar
            heading="Document blueprints"
            subHeading="Ready-made Document templates you can add to your account, alongside the Project Custom Fields that power them."
          />
          <ManageableItemsList.Table
            uniqueKey="id"
            items={blueprints}
            isLoading={isLoading}
            emptyText="No Document blueprints are available"
            onClickRow={(row) => {
              history.push(`/document-blueprints/${row.id}`);
            }}
          >
            <ManageableItemsList.Table.Column
              field="name"
              header="Name"
              render={(name, item) => (
                <AnchorButton
                  as={Link}
                  to={`/document-blueprints/${item.id}`}
                  variant="link-inline"
                >
                  {name}
                </AnchorButton>
              )}
            />
            <ManageableItemsList.Table.Column
              field="description"
              header="Description"
              className="whitespace-normal"
              render={(description) => description ?? '—'}
            />
          </ManageableItemsList.Table>
        </ManageableItemsList>
      </div>
    </AuthenticatedPageWrapper>
  );
};

export default DocumentBlueprintLibraryPage;
